// Libs
import { ReactElement } from 'react';
import clsx from 'clsx';
import { Badge } from 'ui-components';
// App
import styles from './pending-count-badge.module.scss';
import { Props } from './pending-count-badge.props';

const PENDING_COUNT_MAX = 99;

const PendingCountBadge = (props: Props): ReactElement => {
  const { count, children } = props;
  const hasPendingItems = count > 0;
  const isInline = !children;

  return (
    <>
      {!hasPendingItems && children}
      {hasPendingItems && (
        <Badge
          badgeContent={count}
          max={PENDING_COUNT_MAX}
          color="tertiary"
          className={clsx(isInline && styles.inline)}
        >
          {children}
        </Badge>
      )}
    </>
  );
};

export default PendingCountBadge;
